import * as angular from "angular";
import {ILogService} from "angular";
import * as _ from "lodash";
import {AgentRequests} from "./agent-requests.service";
import {AgentsAlerts} from "./agents-alerts.service";
import {AgentsService} from "./agents-service.service";
import {AgentModel} from "../angular/models/agent.model";
import {LocationType} from "../../commons/types/location.type";
import {$agentFactory} from "../$agent.factory";
import {SplitService} from "../../commons/services/split-service.service";
import {$agentsFactory} from "../$agents.factory";
import {DeliveriesRequestsService} from "../../deliveries/services/deliveries-requests.service";
import {SettingsService} from "../../site-preferences/services/settings-service.service";
import {CommonsAlertsService} from "../../commons/services/commons-alerts.service";
import {PhoneAndEmailFactoryService} from "../../commons/services/phone-and-email-factory.service";
import {WorkingSlotStatusType} from "../../working-slots/types/working-slot-status.type";
import {TagType} from "../../tags/angular/types/tag.type";
import {DashboardsServiceService} from "../../dashboards/services/dashboards-service.service";
import {WidgetDatasourceEnum} from "../../dashboards/enums/widget-datasource.enum";
import {AttendanceRequestsService} from "../../timekeeping/services/attendance-requests.service";
import {ClockInResourceProviderType} from "../../timekeeping/angular/models/planned-resource.model";
import {ResourceScopeType} from "../types/resourceScope.type";
import {SiteContextService} from "../../commons/services/site-context.service";
import {AssignIgnoreScoreOptionType} from "../../deliveries/types/assign-ignore-score-option.type";
import {BreakType} from "../../site-preferences/models/break-type.model";
export class AgentDialogService {

  /* @ngInject */
  constructor(private $mdDialog, private $log: ILogService, private phoneAndEmailFactoryService: PhoneAndEmailFactoryService, private splitConstants,
              private splitService: SplitService, private $agent: $agentFactory, private $filter, private agentsAlerts: AgentsAlerts, private commonsAlertsService: CommonsAlertsService,
              private uploadFile, private $deliveries, private deliveriesRequestsService: DeliveriesRequestsService, private moment, private settingsService: SettingsService,
              private attendanceRequestsService: AttendanceRequestsService, private $q, private siteContextService: SiteContextService) {
  }

  editUserPersonalInfo(event, agent: AgentModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-personal-info-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.payload = angular.copy(agent);

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;
        $scope.today = self.moment.utc().startOf('day');


        // ******************************
        // External methods
        // ******************************
        if (!_.isUndefined($scope.payload.user.dateOfBirth)) {
          $scope.payload.user.dateOfBirth = new Date($scope.payload.user.dateOfBirth);
        }

        // let phoneChange = $scope.$watch('payload', (payload) => {
        //   if (payload) {
        //     $scope.payload.user.mobilePhone = this.$filter('bringozPhone')($scope.payload.user.mobilePhone);
        //     phoneChange();
        //   }
        // });

        $scope.onBirthDateChange = (selectedDate) => {
          $scope.payload.user.dateOfBirth = selectedDate;
        }

        $scope.onEmploymentDate = (selectedDate) => {
          $scope.payload.employmentDate = selectedDate;
        }

        $scope.onEmergencyContactNameChange = (name) => {
          if (!$scope.payload.emergencyContact) {
            $scope.payload.emergencyContact = {};
          }
          $scope.payload.emergencyContact.name = name;
        }

        $scope.onEmergencyContactPhoneNoChange = (phone) => {
          if (!$scope.payload.emergencyContact) {
            $scope.payload.emergencyContact = {};
          }
          $scope.payload.emergencyContact.phoneNo = phone;
        }

        $scope.onUserChange = (user) => {
          $scope.payload.user = user;
        }

        $scope.confirm = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if (self.phoneAndEmailFactoryService.isPhoneOrEmailChanged($scope.payload, agent)) {

                self.phoneAndEmailFactoryService.validatePhoneAndEmail($scope.payload, agent)
                  .then(() => {
                    $scope.payload.user.mobilePhone = self.$filter('bringozPhonePrefix')($scope.payload.user.mobilePhone);
                    $scope.doUpdate();
                  })
                  .catch((result) => {
                    $scope.userCredentialsValidity = result;
                  })

              } else {
                $scope.doUpdate();
              }

            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentInfo@confirm')
          }

        }

        $scope.doUpdate = () => {
          loadingState(true);
          self.$agent(agent.id).$post($scope.payload)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              loadingState(false);
              self.$log.error('Failed to update agents personal info, ' +
                'agentDialogService@editUserPersonalInfo' + error)
            })
        }

        function loadingState(state) {
          $scope.loading = state;
        }

      }
    })
  }

  editAgentLicenseInfo(event, agent: AgentModel) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-license-info-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, splitConstants) {

        $scope.loading = false;
        $scope.payload = angular.copy(agent);

        if (_.isUndefined($scope.payload.licenseInfo)) {
          _.set($scope.payload, 'licenseInfo', {})
        }


        if (_.isUndefined($scope.payload.licenseInfo.moreThenOneYear)) {
          $scope.payload.licenseInfo.moreThenOneYear = false;
        }
        if (_.isUndefined($scope.payload.licenseInfo.drivenWithAnother)) {
          $scope.payload.licenseInfo.drivenWithAnother = false;
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.states = self.splitService.getSiteStates();


        if (_.isUndefined($scope.payload.licenseInfo)) {
          $scope.payload.licenseInfo = {};
        }

        if (!_.isUndefined($scope.payload.licenseInfo.imageUrl)) {
          $scope.status = 'complete';
        } else {
          $scope.status = 'idle';
        }

        if (!_.isUndefined($scope.payload.licenseInfo.expirationDate)) {
          $scope.payload.licenseInfo.expirationDate = new Date($scope.payload.licenseInfo.expirationDate);

        }

        // ******************************
        // External methods
        // ******************************

        $scope.onDateChange = (date) => {
          $scope.payload.licenseInfo.expirationDate = date;
        }


        $scope.submit = (form) => {

          if (form) {

            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.doUpdate();
            }

          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentInfo@confirm')
          }

        }

        $scope.upload = ($files) => {
          if (!_.isEqual($files, null) && !_.isEmpty($files)) {

            $scope.status = 'uploading';
            self.uploadFile($files[0]).then((response) => {
              $scope.payload.licenseInfo.imageUrl = _.get(response, 'data.url');
              $scope.status = 'complete';
            });

          } else {
            self.commonsAlertsService.somethingWentWrongError();
          }
        }

        $scope.doUpdate = () => {
          loadingState(true);
          self.$agent(agent.id).$post($scope.payload)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              loadingState(false);
              self.$log.error('Failed to edit Agent License Info, ' +
                'agentDialogService@editAgentLicenseInfo' + error)
            })
        }

        function loadingState(state) {
          $scope.loading = state;
        }


      }
    })
  }

  editUserResidentialAddress(event, agent: AgentModel) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-residential-address-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.agent = angular.copy(agent);

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onAddressChange = function (address) {
          $scope.agent.address = address;
        };


        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.doUpdate();
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editUserResidentialAddress@confirm')
          }
        }

        $scope.doUpdate = () => {
          loadingState(true);
          self.$agent(agent.id).$post($scope.agent)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              loadingState(false);
              self.$log.error('Failed to edit User Residential Address, ' +
                'agentDialogService@editUserResidentialAddress' + error)
            })
        }

        function loadingState(state) {
          $scope.loading = state;
        }

      }
    })
  }

  editComments(event, agent: AgentModel) {

    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-comments-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.payload = angular.copy(agent);


        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = () => {
          $scope.doUpdate();
        }

        $scope.doUpdate = () => {
          loadingState(true);
          self.$agent(agent.id).$post($scope.payload)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              loadingState(false);
              self.$log.error('Failed to edit Comments, ' +
                'agentDialogService@editComments' + error)
            })
        }

        function loadingState(state) {
          $scope.loading = state;
        }

      }
    })
  }


  uploadDocuments(event, agent: AgentModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/upload-documents-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.loading = false;
        $scope.agent = angular.copy(agent);

        $scope.cancel = self.$mdDialog.cancel;

        $scope.status = {
          uploadMvr: _.has($scope.agent, 'licenseInfo.drivingHistoryReportUrl') ? 'complete' : 'idle',
          uploadBC: _.has($scope.agent, 'documents.backgroundCheck.url') ? 'complete' : 'idle',
          uploadW9: _.has($scope.agent, 'documents.w9.url') ? 'complete' : 'idle'
        };


        $scope.submit = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            $scope.doUpdate();
          }
        }

        $scope.uploadMvr = ($files) => {

          $scope.status.uploadMvr = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.status.uploadMvr = 'complete';
              _.set($scope.agent, 'licenseInfo.drivingHistoryReportUrl', _.get(response, 'data.url'));
            })
            .catch((error) => {
              $scope.status.uploadMvr = 'idle';
              self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadMvr', error);
            })

        }

        $scope.uploadBC = ($files) => {
          $scope.status.uploadBC = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.status.uploadBC = 'complete';
              _.set($scope.agent, 'documents.backgroundCheck.url', _.get(response, 'data.url'));
            })
            .catch((error) => {
              $scope.status.uploadBC = 'idle';
              self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadBC', error);
            })

        }
        $scope.uploadW9 = ($files) => {

          $scope.status.uploadW9 = 'upload';
          self.uploadFile($files[0])
            .then((response) => {
              $scope.status.uploadW9 = 'complete';
              _.set($scope.agent, 'documents.w9.url', _.get(response, 'data.url'));
            })
            .catch((error) => {
              $scope.status.uploadW9 = 'idle';
              self.$log.error('Failed to upload file, agentDialogService@uploadDocuments@uploadW9', error);
            })

        }

        $scope.doUpdate = () => {
          $scope.loading = true;
          self.$agent(agent.id).$post($scope.agent)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              $scope.loading = false;
              self.$log.error('Failed to upload Documents, agentDialogService@uploadDocuments', error);
            })
        }
      }
    })
  }

  editRequirement(event, requirement, agent: AgentModel, approveStatus) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-requirement-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope, agentRequests: AgentRequests) {

        $scope.loading = false;
        $scope.states = self.splitService.getSiteStates();
        $scope.dataType = requirement.data.type;
        $scope.today = new Date();
        $scope.payload = angular.copy(requirement);

        $scope.status = _.has(requirement, 'data.url') ? 'complete' : 'idle';

        if (_.isEqual($scope.dataType, 'InsuranceData')) {
          _.set($scope.payload.data, 'expiration', $scope.today)
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.uploadImage = ($files) => {
          $scope.status = 'uploading';
          self.uploadFile($files[0])
            .then((response) => {
              _.set($scope.payload, 'data.url', _.get(response, 'data.url'));
              $scope.status = 'complete';
            })
            .catch((error) => {
              self.$log.error('Failed to upload file, agentDialogService@editRequirement@uploadImage', error);
            })
        }

        $scope.onDateChange = (date) => {
          $scope.payload.data.expiration = date;
        }

        $scope.submit = (form) => {
          form.$setSubmitted(true);
          if (form.$valid) {
            let payload = angular.copy($scope.payload);
            if (_.has(payload, 'data.expiration')) {
              _.set(payload, 'data.expiration', $scope.payload.data.expiration.getTime());
            }
            $scope.uploadImage();
          }
        }

        $scope.uploadImage = () => {
          $scope.loading = true;
          _.set($scope.payload, 'status', approveStatus);
          agentRequests.postRequirements(agent.id, $scope.payload, false, false)
            .then((updatedAgent) => {
              self.$mdDialog.hide(updatedAgent);
            })
            .catch((error) => {
              $scope.loading = false;
              self.$log.error('Failed to upload Documents, agentDialogService@uploadDocuments', error);
            })
        }
      }
    })
  }

  declineRequirement(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/decline-requirement-dialog.tmpl.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {


        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {

          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({
                message: $scope.message,
                sendSms: $scope.sendSms,
                sendEmail: $scope.sendEmail
              });
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentInfo@confirm')
          }

        }


      }
    })
  }

  agentSelection(event, title, avoidIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-selection-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.title = title || 'Driver Selection';
        $scope.avoidIds = avoidIds;
        $scope.selectedAgent = null;
        $scope.selectedAgentIds = [];

        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////
        // ******************************
        // External methods
        // ******************************

        $scope.onSelectAgent = (agent) => {
          $scope.selectedAgent = agent
        }

        $scope.removeAgent = () => {
          $scope.selectedAgent = null
        }

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selectedAgent);
        }


      }
    })
  }

  createAgent(event, account?, branchId?, depotId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-agent.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, agentsService: AgentsService) {

        $scope.account = account;
        $scope.view = account ? 'agent' : 'account'; // account/agent
        $scope.isSingleDriver = true;
        $scope.loading = false;
        $scope.isAgentExternalIdMandatory = self.splitService.getIsAgentExternalIdMandatory();

        $scope.userExistsInDifferentSite = undefined;
        $scope.existingAgentEmail = undefined;

        $scope.agent = {
          user: {
            firstName: undefined,
            lastName: undefined,
            mobilePhone: undefined,
            email: undefined,
            password: undefined
          },
          accountId: _.get(account, 'id'),
          employmentType: _getEmploymentTye(_.get(account, 'type')), // Independent/Payroll
          vehicles: [],
          vehicle: undefined,
          branchIds: []
        };

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onSingleDriverClick = () => {
          $scope.agent.employmentType = 'Independent';
          $scope.view = 'agent';
        }

        $scope.onAccountSelect = (account) => {
          $scope.account = account;
          $scope.agent.accountId = _.get(account, 'id');
          $scope.agent.employmentType = account ? _getEmploymentTye(account.type) : undefined;
          if (account) {
            $scope.view = 'agent';
          }
        }

        $scope.onInviteAccount = (account) => {
          $scope.agent.accountId = account ? account.id : undefined;
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if (!!$scope.agent.user.id) {
                $scope.view = 'confirm';
              } else {
                $scope.createAgent();
              }
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAccount@create');
          }
        }

        $scope.createAgent = () => {
          const agentCopy = angular.copy($scope.agent);
          const prefixedPhone = self.$filter('bringozPhonePrefix')($scope.agent.user.mobilePhone);
          agentCopy.user.mobilePhone = prefixedPhone;

          if (!agentCopy.accountId) {
            agentCopy.account = {
              name: $scope.agent.user.firstName + ' ' + $scope.agent.user.lastName,
              phoneNumber: prefixedPhone,
              country: $scope.agent.country,
              type: 'PrivateSupply'
            }
          }

          if (branchId) {
            agentCopy.branchIds = [branchId];
          }

          if (depotId) {
            agentCopy.depotIds = [depotId];
          }

          $scope.loading = true;
          agentsService.createOne(agentCopy)
            .then((agent) => {
              self.$mdDialog.hide(agent);
            })
            .catch(() => {
              $scope.loading = false;
            })
        }

        function _getEmploymentTye(selectedAccountType) {
          return selectedAccountType
            ? (selectedAccountType === 'PrivateSupply' ? 'Independent' : 'Payroll')
            : undefined
        }


      }
    })
  }

  editAgent(event, agent: AgentModel, canUpdateExternalId?: boolean) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-agent.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, agentsService: AgentsService) {

        $scope.agent = angular.copy(agent);
        // $scope.agent.user.mobilePhone = this.$filter('bringozPhone')(agent.user.mobilePhone);
        $scope.canEditExternalId = canUpdateExternalId || false;
        $scope.isAgentExternalIdMandatory = self.splitService.getIsAgentExternalIdMandatory();

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////
        $scope.logoStatus = 'idle';

        $scope.onAutoStopRecordingIntervalMinutesChange = (autoStopRecordingIntervalMinutes) => {
          $scope.autoStopRecordingIntervalMinutes = autoStopRecordingIntervalMinutes;
        }

        $scope.onLogoUpload = (res) => {
          $scope.logoStatus = 'complete';
          $scope.agent.user.avatarUrl = _.get(res, 'data.url');
        }

        $scope.onDeleteAgentAvatar = () => {
          $scope.logoStatus = 'idle';
          $scope.agent.user.avatarUrl = undefined;
        }

        agentsService.getAgentCrossSiteData(undefined, agent.user.id)
          .then((res: any) => {
            $scope.userHasActiveAgentInAnotherSite = res.userHasActiveAgentInAnotherSite;
          })

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              $scope.agent.user.mobilePhone = self.$filter('bringozPhonePrefix')($scope.agent.user.mobilePhone);

              const payload = {
                agent: $scope.agent,
                autoStopRecordingIntervalMinutes: $scope.autoStopRecordingIntervalMinutes
              }
              self.$mdDialog.hide(payload);
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAccount@create');
          }
        }


      }
    })
  }

  editAgentRouteCostValue(preferences) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-agent-route-cost-value.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {

        $scope.preferences = angular.copy(preferences);
        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.preferences);
            }
          } else {
            self.$log.error('Form resolved to undefined!. --> accountDialogService@createNewShipperAccount@create');
          }
        }

      }
    })
  }

  swapDeliveries(agent: AgentModel, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-swap-deliveries-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope, $agents: $agentsFactory) {

        let deliveriesRef = self.$deliveries();
        let agentsRef = $agents();

        $scope.loading = true;
        $scope.loadingData = false;
        $scope.submitting = false;

        $scope.agentFrom = agent;
        $scope.agentTo = undefined;
        $scope.selectedIds = [];
        $scope.types = {
          Location: 'Driver location',
          OptimizedRoute: 'Optimized driver route',
          AgentRoute: 'Driver scoring'
        };
        $scope.selectedType = {key: 'Location', value: 'Driver location'};
        $scope.assignData = undefined;
        $scope.services = [];
        $scope.queryString = undefined;
        $scope.removeServiceFromRoute = true;

        const siteInfo = self.siteContextService.getSiteInfo();
        $scope.isShowAllToggleVisible = true;
        if (siteInfo.assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOn) {
          $scope.isIgnoreScore = true;
        } else if (siteInfo.assignIgnoreScoreOption === AssignIgnoreScoreOptionType.ShowDefaultOff) {
          $scope.isIgnoreScore = false;
        } else if (siteInfo.assignIgnoreScoreOption === AssignIgnoreScoreOptionType.Hide) {
          $scope.isIgnoreScore = false;
          $scope.isShowAllToggleVisible = false;
        }

        $scope.doForce = !!siteInfo.forceAssignByDefault;

        deliveriesRef.$getAll(_qetQueryPayload())
          .then((ids) => {
            return deliveriesRef.$asyncValues(ids)
          })
          .then((services) => {
            $scope.services = services;
          })
          .catch((error) => {
            self.$log.error('Failed to get agent deliveries ' +
              '@deliveriesDialogService@swapDeliveries', error);
          })
          .finally(() => {
            $scope.loading = false;
          });

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////////////////////

        $scope.selectedIdsChanged = (selectedIds) => {
          $scope.selectedIds = selectedIds;
          $scope.assignData = undefined;
        }

        $scope.onSelectType = (typeKey, typeValue) => {
          $scope.selectedType = {key: typeKey, value: typeValue};
          $scope.getDriversData($scope.queryString);
        }

        $scope.onAgentQueryChange = (query) => {
          $scope.queryString = query;
        }

        $scope.onToggleIsIgnoreScore = (isIgnoreScore) => {
          $scope.isIgnoreScore = isIgnoreScore;
          $scope.assignData = undefined;
          if ($scope.selectedIds.length) {
            $scope.getDriversData();
          }
        }

        $scope.getDriversData = () => {
          $scope.loadingData = true;
          const request = $scope.isIgnoreScore
            ? agentsRef.$getAll(_getIgnoreScoreQueryPayload())
              .then((ids: string[]) => agentsRef.$asyncValues(ids))
              .then((agents) => {
                return {
                  list: _.map(agents, (a) => {
                    return {agentId: a.id, agent: a, score: undefined};
                  })
                };
              })
            : self.deliveriesRequestsService.getAssignAgentData($scope.selectedIds, $scope.selectedType.key, undefined);

          return request
            .then((data) => {
              $scope.assignData = data;
              $scope.assignData.list = _.filter(data.list, (a) => {
                return a.agentId !== $scope.agentFrom.id
              });
            })
            .catch((error) => {
              self.agentsAlerts.getManyError();
              self.$log.error('Failed to get assign data ' +
                '@deliveriesDialogService@swapDeliveries@getDriversData', error);
            })
            .finally(() => {
              $scope.loadingData = false;
            })
        }

        $scope.onAssign = (agent) => {
          $scope.submitting = true;
          $scope.agentTo = agent;
          self.deliveriesRequestsService.assignToAgent($scope.selectedIds, agent.id, $scope.doForce, true, $scope.removeServiceFromRoute)
            .then(() => {
              if ($scope.selectedIds.length > 1) {
                self.agentsAlerts.swapDeliveriesSuccess(agent);
              } else {
                self.agentsAlerts.swapDeliverySuccess(agent);
              }
              self.$mdDialog.hide($scope.selectedIds);
            })
            .catch((error) => {
              if ($scope.selectedIds.length > 1) {
                self.agentsAlerts.swapDeliveriesError();
              } else {
                self.agentsAlerts.swapDeliveryError();
              }
              self.$log.error('Failed to move deliveries between driver as assign', error);
            })
            .finally(() => {
              $scope.submitting = false;
            })
        }

        function _qetQueryPayload() {
          return {
            agentIds: [agent.id],
            status: ['Assigned', 'Started']
          }
        }

        function _getIgnoreScoreQueryPayload() {
          return {
            active: true,
            excludeId: $scope.agentFrom.id
          }
        }


      }
    })
  }

  swapRoutes(agentIds: string[], event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-swap-routes-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.agentIds = agentIds;
        $scope.assignAllServicesToAgent = true;
        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////////////////////////////////

        $scope.onAssignAllServicesToAgentChange = (assignAllServicesToAgent) => {
          $scope.assignAllServicesToAgent = assignAllServicesToAgent;
        }


        $scope.onAssign = (routes, agent) => {
          self.$mdDialog.hide({
            routeIds: _.map(routes, 'id'),
            agentId: agent.id,
            assignAllServicesToAgent: $scope.assignAllServicesToAgent
          });
        }

      }
    })
  }

  addAgent(event, excludeIds) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-agent-dialog.html').default,
      controller: function ($scope, $agents: $agentsFactory, $infiniteScroll) {

        const agentsRef = $agents();
        const loadLimit = 20;

        $scope.queryString = undefined;
        $scope.excludeIds = excludeIds || [];

        agentsRef.$query(_getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(agentsRef, loadLimit);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          _query();
        }

        $scope.onAdd = (agent) => {
          if (agent) {
            self.$mdDialog.hide(agent);
          }
        }

        // ******************************
        //        Private methods
        // ******************************

        function _query() {
          agentsRef.$query(_getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
            .catch((error) => {
            })
        }

        function _getQueryPayload() {
          return {
            limit: loadLimit,
            sortByLoad: true,
            active: true,
            query: $scope.queryString
          }
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addAgents(event, excludeIds, branchId?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-agents-dialog.html').default,
      controller: function ($scope, $agents: $agentsFactory, $infiniteScroll) {

        const agentsRef = $agents();
        const loadLimit = 20;

        $scope.selectedKeys = {};
        $scope.agentIds = [];
        $scope.queryString = undefined;
        $scope.excludeIds = excludeIds ? angular.copy(excludeIds) : [];

        $scope.selectExcludeMode = false;

        agentsRef.$query(_getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(agentsRef, loadLimit);

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          _query();
        }

        $scope.onToggleAgent = (agent) => {
          if (agent) {
            $scope.selectedKeys[agent.id] = !$scope.selectedKeys[agent.id];
            $scope.agentIds = _.keys(_.pickBy($scope.selectedKeys, (value) => {
              return value === true;
            }));
          }
        }

        $scope.onSubmit = () => {
          let payload = {
            ids: $scope.excludeMode ? [] : $scope.agentIds,
            excludeIds: $scope.excludeMode ? $scope.agentIds : []
          }
          self.$mdDialog.hide(payload);
        }

        // ******************************
        //        Private methods
        // ******************************

        function _query() {
          agentsRef.$query(_getQueryPayload())
            .then(function () {
              $scope.infiniteScroll.reload();
            })
            .catch(function (error) {
            })
        }

        function _getQueryPayload() {
          return {
            limit: loadLimit,
            sortByLoad: true,
            active: true,
            query: $scope.queryString,
            branchIds: branchId ? [branchId] : undefined
          }
        }
      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  sendSMS(event, agent: AgentModel) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/send-sms-dialog.html').default,
      controller: function ($scope, messagesRequestsService) {

        $scope.agent = angular.copy(agent);
        $scope.message = undefined;
        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope._sendSMS($scope.message);
            }

          }
        }

        $scope._sendSMS = (message) => {
          const payload = {
            content: message,
            recipient: self.$filter('bringozPhonePrefix')(agent.user.mobilePhone)
          };
          $scope.loading = true;
          messagesRequestsService.sendText(payload)
            .then(() => {
              self.commonsAlertsService.sendSMSSuccess();
              self.$mdDialog.hide();
            })
            .catch((error) => {
              self.commonsAlertsService.sendSMSError();
            })
            .finally(() => {
              $scope.loading = false;
            })
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  itinerarySettings(itinerary, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/itinerary-settings-dialog.html').default,
      controller: function ($scope, commonsConstants) {

        $scope.itinerary = angular.copy(itinerary);
        $scope.locationTypes = commonsConstants.locationTypes;
        $scope.locationTypesMap = LocationType;

        if (!_.get(itinerary, 'endLocation.locationType')) {
          if (!$scope.itinerary.endLocation) {
            $scope.itinerary.endLocation = {};
          }
          $scope.itinerary.endLocation.locationType = 'UNDEFINED';
        }

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onEndTypeChange = (locationType) => {
          $scope.itinerary.endLocation.address = undefined;
          $scope.itinerary.endLocation.id = undefined;
          $scope.itinerary.endLocation.locationType = locationType;
        }

        $scope.onSelectEndDepot = (depot) => {
          _.set($scope.itinerary, 'endLocation.address', _.get(depot, 'address'));
          _.set($scope.itinerary, 'endLocation.id', depot.id);
        }

        $scope.onSelectAddressEndPoint = (address) => {
          _.set($scope.itinerary, 'endLocation.address', address);
          _.set($scope.itinerary, 'endLocation.id', undefined);
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.itinerary);
            }
          }
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  reoptimizeItineraryWithPinnedTasks(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/reoptimize-itinerary-pinned-tasks.html').default,
      controller: function ($scope) {

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////////

        // ******************************
        //        Public methods
        // ******************************

        $scope.onSubmit = (shouldUnpin) => {
          self.$mdDialog.hide(shouldUnpin);
        }


      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: true
    })
  }

  addWalletTransaction(transactionType, agentName, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-wallet-transaction.html').default,
      controller: function ($scope, WalletsConstants, splitService) {

        $scope.transactionTypes = WalletsConstants.transactionTypes;
        $scope.paymentTypes = WalletsConstants.paymentTypes;
        $scope.agentName = agentName;
        $scope.currencySymbol = splitService.getCurrencySymbol();

        $scope.transaction = {
          transactionType: transactionType || WalletsConstants.transactionTypes[0],
          walletTransactionPayments: [
            {
              walletPaymentType: WalletsConstants.paymentTypes[0],
              amount: undefined
            }
          ],
          comment: undefined,
        }

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.transaction);
            }
          }
        };
      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  manageAssistants(agent, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/manage-agent-assistants-dialog.html').default,
      controller: function ($scope, $agentAssistants, $infiniteScroll, $agents: $agentsFactory) {

        const agentsRef = $agents(),
          loadLimit = 20;

        $scope.agent = angular.copy(agent);
        $scope.excludeAgentKeys = {};
        $scope.excludeAgentKeys[agent.id] = true;

        $scope.queryString = undefined;
        $scope.selectedAgentKeys = {};

        _.forEach(agent.agentReferences, (a) => {
          $scope.selectedAgentKeys[a.id] = true;
        })

        agentsRef.$query(_getQueryPayload());
        $scope.infiniteScroll = $infiniteScroll(agentsRef, loadLimit, {getFullData: true});


        $scope.cancel = self.$mdDialog.cancel;
        ////////////////////////////////////////////////////////////////////////////////////////////////////////////////

        $scope.onQueryChange = (query) => {
          $scope.queryString = query;
          _query();
        }

        $scope.onToggle = (agent) => {
          $scope.selectedAgentKeys[agent.id] = !$scope.selectedAgentKeys[agent.id];
        }

        $scope.onReset = () => {
          $scope.selectedAgentKeys = {};
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const updatedAssistants = _.keys(_.pickBy($scope.selectedAgentKeys, _.identity))
              self.$mdDialog.hide(updatedAssistants);
            }
          }
        };

        function _query() {
          agentsRef.$query(_getQueryPayload())
            .then(() => {
              $scope.infiniteScroll.reload();
            })
          // .catch((error) => {
          //   this.$log.error('Fail to $query', error);
          // })
        }

        function _getQueryPayload() {
          return {
            limit: loadLimit,
            excludeId: $scope.agent.id,
            agentType: $scope.agent.agentType,
            branchIds: $scope.agent.branchIds,
            query: $scope.queryString
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: false
    })
  }

  importAgents(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/import-agents-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope, agentRequests: AgentRequests, accountsConstants) {

        $scope.loading = false;
        $scope.file = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        ///////////////////////////////////////////////////////////

        $scope.onAddFile = (file) => {
          $scope.file = file;
        }

        $scope.onDownloadExample = () => {
          const downloadUrl = accountsConstants.importSampleFileLink;
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "import-accounts-example.xls";
          document.body.appendChild(a);
          a.click();
        }

        $scope.onUpload = () => {
          if ($scope.file) {
            $scope.loading = true;
            agentRequests.uploadAgents($scope.file)
              .then((response) => {
                self.$mdDialog.hide(response);
              })
              .catch((error) => {
                self.agentsAlerts.uploadError();
                self.$log.error('Failed to upload excel to server, ' + error);
              })
              .finally(() => {
                $scope.loading = false;
              })
          }
        }


      }
    })
  }

  editAgentWorkingSlot(workingSlot) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/edit-agent-working-slot-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.WorkingSlotStatusType = WorkingSlotStatusType;

        self.settingsService.getAbsenceReasons()
          .then(absenceReasons => {
            $scope.absenceReasons = absenceReasons;
          })
        $scope.workingSlot = angular.copy(workingSlot);
        $scope.WorkingSlotStatuses = Object.values(WorkingSlotStatusType);
        if (_.isUndefined(_.get($scope.workingSlot, 'workingSlotStatus'))) {
          _.set($scope.workingSlot, 'workingSlotStatus', WorkingSlotStatusType.Attendance);
        }
        if (!self.moment(_.get($scope.workingSlot, 'in.time')).isSame(_.get($scope.workingSlot, 'out.time'), 'day')) {
          if (_.get($scope.workingSlot, 'in.time')) {
            _.set($scope.workingSlot, 'out.time', $scope.workingSlot.in.time)
          } else if (!_.get($scope.workingSlot, 'in.time') && !!_.get($scope.workingSlot, 'out.time')) {
            _.set($scope.workingSlot, 'in.time', $scope.workingSlot.out.time)
          }
        }

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        $scope.onStatusChanged = () => {
          $scope.workingSlot.in = {};
          $scope.workingSlot.out = {};
        }
        $scope.onClockInDateChange = (selectedDate) => {
          $scope.workingSlot.in.time = self.moment(selectedDate).startOf('day').valueOf();
        }

        $scope.onClockOutDateChange = (selectedDate) => {
          $scope.workingSlot.out.time = self.moment(selectedDate).endOf('day').valueOf();
        }

        $scope.onClockInTimeChange = (time) => {
          $scope.workingSlot.in.time = time;
        }

        $scope.onClockOutTimeChange = (time) => {
          $scope.workingSlot.out.time = time;
        }

        $scope.confirm = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.workingSlot);
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentWorkingSlot@confirm')
          }

        }
      }
    })
  }

  createAgentWorkingSlots(event, agentId) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-agent-working-slot-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        $scope.WorkingSlotStatusType = WorkingSlotStatusType;

        self.settingsService.getAbsenceReasons()
          .then(absenceReasons => {
            $scope.absenceReasons = absenceReasons;
          })
        $scope.workingSlot = {agentId: agentId}
        $scope.WorkingSlotStatuses = Object.values(WorkingSlotStatusType);
        _.set($scope.workingSlot, 'workingSlotStatus', WorkingSlotStatusType.Attendance);

        $scope.clockInAddress = undefined;
        $scope.clockOutAddress = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        $scope.confirm = confirm;

        $scope.onStatusChanged = () => {
          $scope.workingSlot.in = {};
          $scope.workingSlot.out = {};
        }

        $scope.onClockInDateChange = (selectedDate) => {
          _.set($scope.workingSlot, 'in.time', self.moment(selectedDate).startOf('day').valueOf())
        }

        $scope.onClockOutDateChange = (selectedDate) => {
          _.set($scope.workingSlot, 'out.time', self.moment(selectedDate).endOf('day').valueOf())
        }

        $scope.onClockInTimeChange = (time) => {
          _.set($scope.workingSlot, 'in.time', time)
        }

        $scope.onClockOutTimeChange = (time) => {
          _.set($scope.workingSlot, 'out.time', time)
        }

        $scope.onClockInAddress = (address) => {
          $scope.clockInAddress = address;
        }

        $scope.onClockOutAddress = (address) => {
          $scope.clockOutAddress = address;
        }

        $scope.confirm = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {

              if ($scope.workingSlot.workingSlotStatus === WorkingSlotStatusType.Attendance) {
                _.set($scope.workingSlot, 'in.location', _.get($scope.clockInAddress, 'location'))
                _.set($scope.workingSlot, 'out.location', _.get($scope.clockOutAddress, 'location'))
              }

              const numOfDays = self.moment($scope.workingSlot.out.time).diff(self.moment($scope.workingSlot.in.time), 'days') + 1
              const workingSlotCopy = angular.copy($scope.workingSlot);

              workingSlotCopy.out.time = self.moment($scope.workingSlot.in.time).set({
                year: self.moment($scope.workingSlot.in.time).year(),
                month: self.moment($scope.workingSlot.in.time).month(),
                date: self.moment($scope.workingSlot.in.time).date(),
                hour: self.moment($scope.workingSlot.out.time).hours(),
                minute: self.moment($scope.workingSlot.out.time).minutes(),
                second: self.moment($scope.workingSlot.out.time).seconds()
              }).valueOf();

              const workingSlots = [workingSlotCopy]


              for (let i = 1; i < numOfDays; i++) {
                const nextWorkingSlot = angular.copy(workingSlotCopy);
                nextWorkingSlot.in.time = self.moment(nextWorkingSlot.in.time).add(i, 'days').valueOf();
                nextWorkingSlot.out.time = self.moment(nextWorkingSlot.out.time).add(i, 'days').valueOf();
                workingSlots.push(nextWorkingSlot);
              }

              self.$mdDialog.hide(workingSlots);
            }
          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editAgentWorkingSlot@confirm')
          }

        }
      }
    })
  }


  viewAgentTasks(agent, tasks, isShowDate?, dateRange?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-tasks.html').default,
      fullscreen: true,
      controller: function ($scope) {

        $scope.agent = agent;
        $scope.tasks = tasks;
        $scope.tagTypes = TagType;

        if (isShowDate) {
          $scope.date = self.moment(dateRange.from).valueOf();
          $scope.date = self.moment().valueOf();
        }
        $scope.cancel = self.$mdDialog.cancel;
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  viewAgentTrackingTasks(agent, tasks, dateRange, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-tasks.html').default,
      fullscreen: true,
      controller: function ($scope, dashboardsServiceService: DashboardsServiceService) {

        $scope.agent = agent;
        $scope.tasks = tasks;
        $scope.tagTypes = TagType;
        $scope.date = self.moment(dateRange.from).valueOf();
        $scope.isDatepickerEnabled = true;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onDateChange = (date) => {
          $scope.date = self.moment(date).valueOf();
          const filters = {
            from: self.moment(date).startOf('day').valueOf(),
            to: self.moment(date).endOf('day').valueOf(),
            agentIds: [agent.id]
          }
          $scope.isLoading = true;
          dashboardsServiceService.getDashboardWidgetData(WidgetDatasourceEnum.agentsTracking, filters)
            .then((res: any[]) => {
              $scope.tasks = !!res.length ? res[0].tasks : [];
            })
            .finally(() => {
              $scope.isLoading = false;
            })
        }
      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  viewAgentRouteReportTasks(agent, tasks, routeName?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/agent-route-report-tasks.html').default,
      fullscreen: true,
      controller: function ($scope) {

        $scope.agent = agent;
        $scope.tasks = tasks;
        $scope.routeName = routeName;

        $scope.cancel = self.$mdDialog.cancel;

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  advanceOnDutyOption(event, agentId, agentConfigurationProfile, agentName?: string) {
    const self = this;
    if (!agentId) {
      this.$log.error('Agent ID is required for advance on-duty option');
      return this.$q.reject('Agent ID is required');
    }

    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/advance-on-duty-option-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {
        const clockInPrefs = _.get(agentConfigurationProfile, 'shiftRestrictions.agentClockInProviderPreferences', {});

        $scope.activeTab = clockInPrefs.provider || ClockInResourceProviderType.Shift;
        $scope.scope = clockInPrefs.resourceScope || ResourceScopeType.Dedicated;
        $scope.notBefore = clockInPrefs.resourceVisibilityTimeWindowNotBeforeHours || 3;
        $scope.notAfter = clockInPrefs.resourceVisibilityTimeWindowNotAfterHours || 3;
        $scope.selectedShiftId = null;
        $scope.shifts = [];
        $scope.loading = false;

        // Function to load resources
        $scope.loadResources = () => {
          $scope.loading = true;
          $scope.shifts = [];
          $scope.selectedShiftId = null;

          const now = new Date().getTime();
          const notBeforeMs = $scope.notBefore * 60 * 60 * 1000;
          const notAfterMs = $scope.notAfter * 60 * 60 * 1000;

          const params: any = {
            agentId: agentId,
            provider: $scope.activeTab,
            from: now - notBeforeMs,
            to: now + notAfterMs,
            scope: $scope.scope,
            limit: 20
          };

          // Add search query if provided
          if ($scope.searchQuery && $scope.searchQuery.trim()) {
            params.query = $scope.searchQuery.trim();
          }

          self.attendanceRequestsService.getClockInResources(params)
            .then((response: any) => {
              // Handle response - could be array directly, or object with list property
              const list = Array.isArray(response) ? response : (response?.list || response?.data?.list || []);

              $scope.$applyAsync(() => {
                if (!list || list.length === 0) {
                  $scope.shifts = [];
                  $scope.loading = false;
                  return;
                }

                $scope.shifts = list.map((resource) => {
                  // Use agentReference if available, otherwise use current agent name, fallback to '-'
                  const extractedAgentName = _.get(resource, 'agentReference.fullName') ||
                            (_.get(resource, 'agentReference.firstName') && _.get(resource, 'agentReference.lastName')
                              ? `${resource.agentReference.firstName} ${resource.agentReference.lastName}`
                              : (agentName || '-'));

                  return {
                    id: resource.id,
                    name: resource.name || '-',
                    agentName: extractedAgentName,
                    stops: resource.stops || 0,
                    timeWindow: self.$filter('bringozTime')({time: resource.startTime}, 'time') + ' - ' + self.$filter('bringozTime')({time: resource.endTime}, 'time'),
                    provider: resource.provider || $scope.activeTab
                  };
                });

                // Auto-select first shift
                if ($scope.shifts.length > 0) {
                  $scope.selectedShiftId = $scope.shifts[0].id;
                }
                $scope.loading = false;
              });
            })
            .catch((error) => {
              console.error('Failed to load resources:', error);
              $scope.$applyAsync(() => {
                $scope.shifts = [];
                $scope.loading = false;
              });
            });
        };

        // Initial load
        $scope.loadResources();

        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          const selectedShift = $scope.shifts.find(s => s.id === $scope.selectedShiftId);
          if (!selectedShift) {
            self.$log.error('No shift selected');
            return;
          }

          $scope.loading = true;

          self.attendanceRequestsService.clockIn(agentId, {
            id: selectedShift.id,
            providerType: selectedShift.provider
          })
            .then((response) => {
              self.$mdDialog.hide(response);
            })
            .catch((error) => {
              self.$log.error('Failed to clock in:', error);
              self.agentsAlerts.updateStatusError(error);
              $scope.loading = false;
            });
        };
      }
    });
  }

  selectBreakType(event, breakTypes: BreakType[]) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-break-type-dialog.html').default,
      targetEvent: event,
      clickOutsideToClose: true,
      controller: function ($scope) {
        const defaultBreakType = _.find(breakTypes, {default: true}) || _.head(breakTypes);

        $scope.breakTypes = breakTypes;
        $scope.selected = {breakTypeId: _.get(defaultBreakType, 'id')};
        $scope.cancel = self.$mdDialog.cancel;

        $scope.submit = () => {
          self.$mdDialog.hide($scope.selected.breakTypeId);
        };
      }
    });
  }

}

angular
  .module('bringoz.admin.agents')
  .service('agentDialogService', AgentDialogService);
